module.exports = __webpack_public_path__ + "images/emoji/poop.d12d38e92a2adf59aa73.png";